(function ($) {

    $columns = $('ul.products.bundled_products');

    if ($columns.length === 0) {
        return;
    }

    $columns.align({
        selector: '>li .bundled_product_images, >li .bundled_product_title, >li .bundled_item_cart_content'
    });

})(jQuery);